import React from "react";
import { useFormContext } from "react-hook-form";
import { Select } from "components";
import { useGetVetspirePatientsQuery } from "requests";
import { FormValues } from "../../duck";

const Patients: React.FC = () => {
  const { watch } = useFormContext<FormValues>();
  const clientValue = watch("client");
  const { data, loading } = useGetVetspirePatientsQuery({
    variables: { clientId: clientValue as string },
    skip: !clientValue
  });

  return (
    <Select
      name="patient"
      label="Patient"
      placeholder="Choose patient"
      options={
        data?.queryVetspirePatients?.collection.map(patient => ({
          value: patient._id,
          label: patient.name
        })) || []
      }
      isLoading={loading}
    />
  );
};

export default Patients;
